import { useEffect } from 'react';

const SITE_URL = 'https://markipilot.com';
const BRAND = 'marKIpilot';

const setMetaTag = (attr, key, content) => {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
};

export const Seo = ({ title, description, path = '/', ogType = 'website', noindex = false, jsonLd = null }) => {
  const fullTitle = `${title} | ${BRAND}`;
  const url = `${SITE_URL}${path}`;
  const image = `${SITE_URL}/og-image.jpg`;

  useEffect(() => {
    document.title = fullTitle;
    document.documentElement.lang = 'de';
    setMetaTag('name', 'description', description);
    setMetaTag('name', 'robots', noindex ? 'noindex, nofollow' : 'index, follow');
    setMetaTag('property', 'og:title', fullTitle);
    setMetaTag('property', 'og:description', description);
    setMetaTag('property', 'og:image', image);
    setMetaTag('property', 'og:url', url);
    setMetaTag('property', 'og:type', ogType);
    setMetaTag('property', 'og:site_name', BRAND);
    setMetaTag('property', 'og:locale', 'de_CH');
    setMetaTag('name', 'twitter:card', 'summary_large_image');
    setMetaTag('name', 'twitter:title', fullTitle);
    setMetaTag('name', 'twitter:description', description);
    setMetaTag('name', 'twitter:image', image);

    let canonical = document.head.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.setAttribute('rel', 'canonical');
      document.head.appendChild(canonical);
    }
    canonical.setAttribute('href', url);

    let script = null;
    if (jsonLd) {
      script = document.createElement('script');
      script.type = 'application/ld+json';
      script.text = JSON.stringify(jsonLd);
      document.head.appendChild(script);
    }
    return () => { if (script) script.remove(); };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fullTitle, description, url, ogType, noindex]);

  return null;
};

export default Seo;
